import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateBarcode($companyId: ID!, $id: ID!, $attributes: BarcodeAttributes!) {
    updateBarcode(companyId: $companyId, id: $id, attributes: $attributes) {
      barcode {
        id
        ...UpdatedBarcode
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedBarcode on Barcode {
    id
    barcode
    barcodeNumber
  }
`
